var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDatabase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M100.418,24.343a250.694,250.694,0,0,1-54.932-5.819Q19.52,12.7,4.538,1.551V36.719h0q0,14.548,27.965,24.732t67.915,10.183q39.951,0,67.915-10.183T196.3,36.719V1.551q-14.981,11.154-40.949,16.973A250.684,250.684,0,0,1,100.418,24.343Z",
    fill: "#1B8646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.418,87.419A250.633,250.633,0,0,1,45.486,81.6Q19.52,75.782,4.538,64.628V99.8h0q0,14.549,27.965,24.731t67.915,10.184q39.951,0,67.915-10.184T196.3,99.8V64.628Q181.318,75.781,155.349,81.6A250.623,250.623,0,0,1,100.418,87.419Z",
    fill: "#1B8646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.418,151.007a250.694,250.694,0,0,1-54.932-5.819q-25.966-5.82-40.948-16.973v35.168h0q0,14.548,27.965,24.732T100.418,198.3q39.951,0,67.915-10.183T196.3,163.383V128.215q-14.981,11.154-40.949,16.973A250.684,250.684,0,0,1,100.418,151.007Z",
    fill: "#1B8646"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/database.868103a48365af68ae4d4817b3869685.svg";
export { ForwardRef as ReactComponent };